@if (tooltipNotifications.error?.length) {
  @for (error of tooltipNotifications.error; track error) {
    <div class="error-container">
      <span id="errorMessage" class="error-message">{{ error.description }}</span>
      @if (error.oemSkuProductNumbers?.length) {
        <mat-radio-group aria-label="Select an option" class="column-options" (click)="$event.stopPropagation()">
          @for (productNumber of error.oemSkuProductNumbers; track productNumber; let index = $index) {
            <mat-radio-button
              [value]="productNumber" [checked]="index === 0" (change)="toggleOemSkuRadio($event)">
              {{ productNumber }}
            </mat-radio-button>
          }
        </mat-radio-group>
      }
      @if (error.buttons?.length > 0) {
        <span class="button-container">
          <span class="whitespace"></span>
          @if (error.buttons?.length > 0) {
            <div id="errorButtonContainer" class="notice-button-container">
              @for (cbButton of error.buttons; track cbButton) {
                <ds-button id="errorButton" variant="label-only" type="primary"
                  [isDisabled]="!canEdit" size="medium"
                  (click)="handleNotification(error, cbButton)" [label]="cbButton?.label">
                </ds-button>
              }
            </div>
          }
        </span>
      }
    </div>
  }
}
@if (tooltipNotifications.warning?.length && !tooltipNotifications.error?.length) {
  @for (warning of tooltipNotifications.warning; track warning) {
    <div class="warning-container">
      <span class="warning-message">{{ warning.description }}</span>
      @if (warning.buttons?.length > 0) {
        <span class="button-container">
          <span class="whitespace"></span>
          @if (warning.buttons?.length > 0 && warning.buttons[0]) {
            @for (cbButton of warning.buttons; track cbButton) {
              <ds-button id="warningButton" variant="label-only" type="primary"
                [isDisabled]="!canEdit" size="medium"
                (click)="handleNotification(warning, cbButton)" [label]="cbButton?.label">
              </ds-button>
            }
          }
        </span>
      }
    </div>
  }
}
@if (tooltipNotifications.info?.length && !tooltipNotifications.warning?.length && !tooltipNotifications.error?.length) {
  @for (info of tooltipNotifications.info; track info) {
    @if (info.messageCodeId===11 || info.messageCodeId===12) {
      @if (info.messageCodeId===11) {
        <div class="info-container">
          <span id="description">{{ info.description }}</span>
          <div (click)="$event.stopPropagation()" class="radio-group-container">
            <mat-radio-group id="quoteItemizeOptionsGroup" class="itemize-options" [(ngModel)]="selection"
              id="itemizeOptions" aria-label="Select an option">
              <mat-radio-button id="itemize_1" value="1">{{ appStrings.quote_itemize_option_1 }}</mat-radio-button>
              <mat-radio-button id="itemize_2" value="2">{{ appStrings.quote_itemize_option_2 }}</mat-radio-button>
              <mat-radio-button id="itemize_3" value="3">{{ appStrings.quote_itemize_option_3 }}</mat-radio-button>
            </mat-radio-group>
          </div>
          <div id="confirm" class="notice-button-container">
            <ds-button id="confirmButton" variant="label-only" type="primary"
              [isDisabled]="selectedTool?.isLoading || !canEdit || !selection" size="medium" (click)="itemizeAction(selection, info)"
              [label]="appStrings.button_confirm">
            </ds-button>
          </div>
        </div>
      } @else {
        <div class="promotion info-container">
          <span id="titleContainer" class="info-message title-info">
            <span id="productName" class="product-name">{{ selectedTool.productNumber }}</span>
            {{ appStrings.promotionTitle }}
          </span>
          <div id="description-container" class="descriptionContainer">
            <span class="info-message">{{ appStrings.promotionDescription }}</span>
          </div>
          <div id="tableInfo" class="table-info">
            <span id="promoPriceLabel" class="header-text">{{ appStrings.promoPriceLabel }}</span>
            <span id="promoPriceValue" class="header-text">
              {{ info.promoPrice.listPrice | currency: currencySymbol }}
            </span>
            <span id="currentPriceLabel">{{ appStrings.currentPriceLabel }}</span>
            <span id="currentPriceLabel">{{ selectedTool.listPrice | currency: currencySymbol }}</span>
            <span id="startDateLabel">{{ appStrings.startDate }}</span>
            <span id="startDateLabel">{{ info.promoPrice.startDate | date : formatDate }}</span>
            <span id="endDateLabel">{{ appStrings.endDate }}</span>
            <span id="endDateLabel">{{ info.promoPrice.endDate | date : formatDate }}</span>
          </div>
          <div id="priceButtons" class="button-container">
            <ds-button id="currentPriceButton" variant="label-only" type="secondary"
              [isDisabled]="!canEdit" size="medium" (click)="useCurrentPrice(info)"
              [label]="appStrings.currentPriceButton">
            </ds-button>
            <ds-button id="promoPriceButton" variant="label-only" type="primary"
              [isDisabled]="!canEdit" size="medium" (click)="usePromoPrice(info.id)"
              [label]="appStrings.promoPriceButton">
            </ds-button>
          </div>
        </div>
      }
    } @else {
      <div class="info-container">
        <span class="info-message">{{ info.description }}</span>
        @if (info.buttons?.length > 0 && info.buttons[0]) {
          <div class="button-container">
            <ng-container>
              @for (cbButton of info.buttons; track cbButton) {
                <ds-button id="infoButton" variant="label-only" type="primary"
                  [isDisabled]="!canEdit" size="medium" (click)="handleNotification(info, cbButton)"
                  [label]="cbButton.label">
                </ds-button>
              }
            </ng-container>
          </div>
        }
      </div>
    }
  }
}